import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../../actions/settings";
import { IonButton, IonItem, IonRow, IonSpinner, IonToggle } from "@ionic/react";
import CurrencyInput from 'react-currency-input-field';
import LoadingSpinner from "../../../extras/LoadingSpinner";
import NotificationPopUp from "../../../extras/NotificationPopUp";

interface IProps {
    building:string;
};

async function getCurrentResults(token: string,id:string) {
  return fetch(`${API_URL}/incentive_forecast/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
// body: JSON.stringify(data)
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log("Error", err)
                return false
                // throw error here to use the catch
            })

        }
      }).catch(error => {
        console.log(error)
      });
}

async function getForecast(token: string,id:string,data:any) {
  return fetch(`${API_URL}/incentive_forecast/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
body: JSON.stringify(data)
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log("Error", err)
                NotificationPopUp('Error',err)
                return false
                // throw error here to use the catch
            })

        }
      }).catch(error => {
        console.log(error)
      });
}
async function toggleActivate(token: string,id:string) {
  return fetch(`${API_URL}/incentive_forecast/activate/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log("Error", err)
                NotificationPopUp('Error',err)
                return false
            })

        }
      }).catch(error => {
        console.log(error)
      });
}

const defaultData = {
		"id": null,
		"active": false,
		"kwh_incentive_rate": 0,
		"therm_incentive_rate": 0,
		"kwh_incentive_cap": 0,
		"therm_incentive_cap": 0,
		"percent_targeted_kwh": 0,
		"percent_targeted_therm": 0,
		"kwh_savings_target": 0,
		"therm_savings_target": 0,
		"forecast_kwh_savings": 0,
		"forecast_therm_savings": 0,
		"total_incentive_forecast": 0,
		"building": "null"
	}



const IncentiveResults:FC<IProps> = (props) => {
    const [results, setResults] = useState(defaultData)
    const [loading,setLoading] = useState(true)
    const [calculating,setCalculating] = useState(false)

    const handleResults = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const res = await getCurrentResults(token,props.building)
      if(res){
        setResults(res.data)
      }
      setLoading(false)

    };

    const handleForecast = async () => {
        setCalculating(true)
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const data = {
            "kwh_rate":results['kwh_incentive_rate'],
            "therm_rate":results['therm_incentive_rate'],
            "kwh_cap":results['kwh_incentive_cap'],
            "therm_cap":results['therm_incentive_cap']
        }
      const res = await getForecast(token,props.building,data)
      if(res.status === 'success'){
        setResults(res.data)
      }
      setCalculating(false)

    };

    const handleToggleActivate = async () => {
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const res = await toggleActivate(token,props.building)
        if(res.status === 'success'){
        handleInput('active',res.data.active)
      }
    }

    useEffect(()=>{
        handleResults()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.building])


    const handleInput = async (name:string,value:any) => {
        setResults((prevState: any) => {
        return {
            ...prevState,
            [name]: value,
        };
        });
    }

    if(loading){
        return <LoadingSpinner/>
    }

    console.log(results)
    return <div>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonToggle checked={results['active']} onIonChange={(e)=>{handleToggleActivate()}}>Active</IonToggle>
        </IonItem>
        <IonItem color='medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>kWh Incentive Rate</div>
                <div style={{color:'black'}}>
                    <CurrencyInput
                    name="kwh_incentive_rate"
                    defaultValue={results['kwh_incentive_rate']}
                    decimalsLimit={2}
                    prefix="$"
                    style={{width:'50px',textAlign:'right'}}
                    onValueChange={(value, name,values)=> {handleInput(name!,values!.float)}}
                    maxLength={5}
                    allowNegativeValue={false}
                    />
                </div>              
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Therm Incentive Rate</div>
                <div style={{color:'black'}}>
                    <CurrencyInput
                    name="therm_incentive_rate"
                    allowDecimals={true}
                    defaultValue={results['therm_incentive_rate']}
                    decimalsLimit={2}
                    prefix="$"
                    style={{width:'50px',textAlign:'right'}}
                    onValueChange={(value, name,values)=> {handleInput(name!,values!.float)}}
                    maxLength={5}
                    allowNegativeValue={false}
                    />
                </div>              
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>kWh Incentive $ Cap</div>
                <div style={{color:'black'}}>
                    <CurrencyInput
                    name="kwh_incentive_cap"
                    defaultValue={results['kwh_incentive_cap']}
                    decimalsLimit={2}
                    prefix="$"
                    style={{textAlign:'right'}}
                    onValueChange={(value, name,values)=> {handleInput(name!,values!.float)}}
                    allowNegativeValue={false}
                    />
                </div>              
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Therm Incentive $ Cap</div>
                <div style={{color:'black'}}>
                    <CurrencyInput
                    name="therm_incentive_cap"
                    defaultValue={results['therm_incentive_cap']}
                    decimalsLimit={2}
                    prefix="$"
                    style={{textAlign:'right'}}
                    onValueChange={(value, name,values)=> {handleInput(name!,values!.float)}}
                    allowNegativeValue={false}
                    />
                </div>              
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>% of Targeted kWhs</div>
                <div>{Math.round(results['percent_targeted_kwh']*100)}%</div>
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>% of Targeted Therms</div>
                <div>{Math.round(results['percent_targeted_therm']*100)}%</div>
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Annual kWh Savings Target</div>
                <div>{results['kwh_savings_target'].toLocaleString("en-US")}</div>
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Annual Therm Savings Target</div>
                <div>{results['therm_savings_target'].toLocaleString("en-US")}</div>
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Forecast kWh Savings</div>
                <div>{results['forecast_kwh_savings'].toLocaleString("en-US")}</div>
            </IonRow>
        </IonItem>
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Forecast Therm Savings</div>
                <div>{results['forecast_therm_savings'].toLocaleString("en-US")}</div>
            </IonRow>
        </IonItem >
        <IonItem style={{'--background':'transparent'}} color = 'medium'>
            <IonRow className="ion-justify-content-between" style={{width:'100%'}}>
                <div>Total Incentive Forecast</div>
                <div>${results['total_incentive_forecast'].toLocaleString("en-US")}</div>
            </IonRow>
        </IonItem>
        <div style={{width:'100%',textAlign:'left'}}>
            <IonButton disabled={calculating} onClick={()=>handleForecast()}>{calculating? <IonSpinner/> : "Calculate"}</IonButton>
        </div>
    </div>
};

export default IncentiveResults;